import phone1 from '../assets/images/phone/1.png';
import phone2 from '../assets/images/phone/2.png';
import phone3 from '../assets/images/phone/3.png';
import phone4 from '../assets/images/phone/4.png';
import phone5 from '../assets/images/phone/5.png';
import phone6 from '../assets/images/phone/6.png';
import phone7 from '../assets/images/phone/7.png';
import phone8 from '../assets/images/phone/8.png';
import phone9 from '../assets/images/phone/9.png';
import phone10 from '../assets/images/phone/10.png';
import phone11 from '../assets/images/phone/11.png';
import phone12 from '../assets/images/phone/12.png';
import phone13 from '../assets/images/phone/13.png';
import phone14 from '../assets/images/phone/14.png';

import client1 from '../assets/images/client/isa-yeter.jpeg';
import client2 from '../assets/images/client/02.jpg';
import client3 from '../assets/images/client/03.jpg';
import client4 from '../assets/images/client/4.png';

import company1 from '../assets/images/client/Kandilli_Rasathanesi_ve_Deprem_Araştırma_Enstitüsü_logosu.jpg';

import {
  FiAlertTriangle,
  FiBarChart2,
  FiBook,
  FiCpu,
  FiDatabase,
  // FiEye,
  // FiFeather,
  // FiHeart,
  FiInfo,
  FiMaximize,
  // FiMonitor,
  FiNavigation2,
  FiPieChart,
  FiShield,
  // FiSmartphone,
  // FiUserCheck,
} from 'react-icons/fi';

export const feature = [
  {
    icon: FiMaximize,
    title: 'Fully functional',
    desc: 'The phrasal sequence of the is now so that many campaign and benefit',
    active: true,
  },
  {
    icon: FiPieChart,
    title: 'Secure Data',
    desc: 'The phrasal sequence of the is now so that many campaign and benefit',
    active: false,
  },
  {
    icon: FiNavigation2,
    title: 'Track Location',
    desc: 'The phrasal sequence of the is now so that many campaign and benefit',
    active: true,
  },
  {
    icon: FiDatabase,
    title: 'Data Analyse',
    desc: 'The phrasal sequence of the is now so that many campaign and benefit',
    active: false,
  },
];

export const feature2 = [
  {
    icon: FiAlertTriangle,
    title: 'feature2.0.title',
    desc: 'feature2.0.desc',
  },
  {
    icon: FiBarChart2,
    title: 'feature2.1.title',
    desc: 'feature2.1.desc',
  },
  {
    icon: FiInfo,
    title: 'feature2.2.title',
    desc: 'feature2.2.desc',
  },
];

export const feature3 = [
  {
    icon: FiBook,
    title: 'feature3.0.title',
    desc: 'feature3.0.desc',
  },
  {
    icon: FiShield,
    title: 'feature3.1.title',
    desc: 'feature3.1.desc',
  },
  {
    icon: FiCpu,
    title: 'feature3.2.title',
    desc: 'feature3.2.desc',
  },
];

export const screenshotImg = [
  phone1,
  phone2,
  phone3,
  phone4,
  phone5,
  phone6,
  phone7,
  phone8,
  phone9,
  phone10,
  phone11,
  phone12,
  phone13,
  phone14,
];

export const faq = [
  {
    id: 1,
    title: 'faq.items.0.title',
    desc: 'faq.items.0.desc',
  },
  {
    id: 2,
    title: 'faq.items.1.title',
    desc: 'faq.items.1.desc',
  },
  {
    id: 3,
    title: 'faq.items.2.title',
    desc: 'faq.items.2.desc',
  },
  {
    id: 4,
    title: 'faq.items.3.title',
    desc: 'faq.items.3.desc',
  },
];

export const clientData = [
  {
    image: client1,
    name: 'clients.items.0.name',
    position: 'Product Manager',
    company: 'U.D.U.S Teknoloji',
    companyLink: 'https://udus.com.tr/',
    linkedin: 'https://www.linkedin.com/in/isa-yeter-20b99a40/',
    twitterx: 'https://x.com/isayeter',
    instagram: 'https://www.instagram.com/theone/',
  },
  {
    image: client2,
    name: 'clients.items.1.name',
    position: 'clients.items.1.position',
    position2: 'clients.items.1.position2',
    company: 'Boğaziçi Üniversitesi Kandilli Rasathanesi',
    companyLink: 'https://www.boun.edu.tr/',
    website: 'https://jeodezi.bogazici.edu.tr/tr/semihergintav',
  },
  {
    image: client3,
    name: 'clients.items.2.name',
    position: 'clients.items.2.position',
    position2: 'clients.items.2.position2',
    company: 'Boğaziçi Üniversitesi Kandilli Rasathanesi',
    companyLink: 'https://www.boun.edu.tr/',
    website:
      'http://www.koeri.boun.edu.tr/jeofizik/2/kisiler/ogretim-uyeleri/doc-dr-ali-ozgun-konca/',
  },
  {
    image: client4,
    name: 'clients.items.3.name',
    position: 'clients.items.3.position',
    position2: 'clients.items.3.position2',
    company: 'Boğaziçi Üniversitesi Kandilli Rasathanesi',
    companyLink: 'https://www.boun.edu.tr/',
    website: 'http://www.koeri.boun.edu.tr/sismo/2/staff/fatih-turhan/',
  },
];

// export const clientData = [
//   {
//     image: client1,
//     name: 'İsa Yeter',
//     position: 'Proje koordinatörü ve yazılımcısı',
//     desc: `" It seems that only fragments of the original text remain in the Lorem Ipsum texts used today. "`,
//     rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
//   },
//   {
//     image: client2,
//     name: 'Christa Smith',
//     position: 'Manager',
//     desc: `" The most well-known dummy text is the 'Lorem Ipsum', which is said to have originated in the 16th century. "`,
//     rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
//   },
//   {
//     image: client3,
//     name: 'Jemina CLone',
//     position: 'Manager',
//     desc: `" One disadvantage of Lorum Ipsum is that in Latin certain letters appear more frequently than others. "`,
//     rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
//   },
//   {
//     image: client4,
//     name: 'Smith Vodka',
//     position: 'Manager',
//     desc: `" Thus, Lorem Ipsum has only limited suitability as a visual filler for German texts. "`,
//     rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
//   },
//   {
//     image: client5,
//     name: 'Cristino Murfi',
//     position: 'Manager',
//     desc: `" There is now an abundance of readable dummy texts. These are usually used when a text is required. "`,
//     rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
//   },
//   {
//     image: client6,
//     name: 'Cristino Murfi',
//     position: 'Manager',
//     desc: `" According to most sources, Lorum Ipsum can be traced back to a text composed by Cicero. "`,
//     rate: ['mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star', 'mdi mdi-star'],
//   },
// ];

export const companyData = [company1];
